// extracted by mini-css-extract-plugin
module.exports = {"mobileHealthScore":"_2MEBMEUGiTtoDwA92cZYbW"};